// pagySetLimit — update the per-page "items" param and navigate.
//
// When called from inside a <turbo-frame> (pass the select element as the
// second argument), the navigation targets that frame so only the table
// re-renders without a full-page reload.  Falls back to a full-page
// location change on pages that have no enclosing frame.
window.pagySetLimit = function (limit, selectEl) {
  var parts = window.location.href.split('?');
  var base = parts[0];
  var query = parts[1] || '';
  var params = [];
  if (query) {
    var pairs = query.split('&');
    for (var i = 0; i < pairs.length; i++) {
      var key = pairs[i].split('=')[0];
      if (key !== 'items' && key !== 'page') {
        params.push(pairs[i]);
      }
    }
  }
  params.push('items=' + encodeURIComponent(limit));
  var url = base + '?' + params.join('&');

  var frame = selectEl && selectEl.closest('turbo-frame');
  if (frame && window.Turbo) {
    window.Turbo.visit(url, { frame: frame.id });
  } else {
    window.location.href = url;
  }
};
